import React, { useState, useRef } from 'react';
import '../css/SendEmail.css';

const SendEmail = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    message: '',
    attachments: [],
    audioRecording: null,
  });

  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({ ...formData, attachments: [...formData.attachments, ...files] });
  };

  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        audioChunksRef.current.push(event.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
        const audioUrl = URL.createObjectURL(audioBlob);
        setFormData({ ...formData, audioRecording: { blob: audioBlob, url: audioUrl } });
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
      alert('Could not access microphone. Please check your permissions.');
    }
  };

  const handleStopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  // Removed duplicate handleSubmit function

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('message', formData.message);
    formDataToSend.append('to', document.getElementById('to').value);

    // Attach files
    formData.attachments.forEach((file, index) => {
      formDataToSend.append(`attachments[${index}]`, file);
    });

    // Attach audio recording if available
    if (formData.audioRecording) {
      formDataToSend.append('audioRecording', formData.audioRecording.blob, 'audioRecording.wav');
    }

    try {
      const response = await fetch('https://snapcourse.in/notify.php', {
        method: 'POST',
        body: formDataToSend,
      });

      if (response.ok) {
        alert('Email sent successfully!');
      } else {
        alert('Failed to send email. Please try again.');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert('An error occurred while sending the email.');
    }
  };

  return (
    <div className="container">
      <h1 className="heading">Send Email</h1>
      <form onSubmit={handleSubmit} className="form">
        <div className="formGroup">
          <label className="label">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="input"
            placeholder="Enter email title"
            required
          />
        </div>
        <div className="formGroup">
          <label className="label">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            className="textarea"
            placeholder="Enter email description"
            required
          />
        </div>
        <div className="formGroup">
          <label className="label">To</label>
          <select name="to" id="to" style={{ width: '100%' }} required>
            <option value="pm9825167@gmail.com">Ayushi</option>
            <option value="adarsh.singhvishnu@gmail.com">Adarsh</option>
          </select>
        </div>
        <div className="formGroup">
          <label className="label">Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            className="textarea"
            placeholder="Enter your message"
            required
          />
        </div>
        <div className="formGroup">
          <label className="label">Audio Recording</label>
          {isRecording ? (
            <button type="button" onClick={handleStopRecording} className="button">
              Stop Recording
            </button>
          ) : (
            <button type="button" onClick={handleStartRecording} className="button">
              Start Recording
            </button>
          )}
          {formData.audioRecording && (
            <div>
              <p>Audio recording attached. You can preview it below:</p>
              <audio controls src={formData.audioRecording.url}></audio>
            </div>
          )}
        </div>
        <button type="submit" className="button">Send Email</button>
      </form>
    </div>
  );
};

export default SendEmail;
